import paths from "@ingka/icons-shared/paths/warning-triangle";
import { renderPaths } from "../renderPaths.mjs";
var warning_triangle_default = () => renderPaths(paths);
export {
  warning_triangle_default as default
};
